import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Vertical } from '@sbt-web/adv';
import { getVerticalOfCategoryID } from '@sbt-web/category-utils';
import { CategoryID } from '@sbt-web/network/types';
export const useGetVerticalByCategoryId = id => {
  const $ = _c(2);
  let t0;
  if ($[0] !== id) {
    t0 = getVerticalOfCategoryID(id);
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};